import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore';
import React from 'react';
import Tooltip from '../../../components/common/Tooltip';
import shouldShowMatrixRightColumn from '../../../helpers/questionnaire/shouldShowMatrixRightColumn';

const MatrixOneMSI = ({field, index}) => {

    // Firestore
    const matrixRows = useFirestoreGeneralOrderBy('MatrixQuestionRows', 'Field', field.ID, 'Position', 'asc')
    const matrixColumns = useFirestoreGeneralOrderBy('MatrixQuestionColumns', 'Field', field.ID, 'Position', 'asc')

    const bipolar = shouldShowMatrixRightColumn(field)

  return (
    <div id='edit-matrix-container' style={{display: field.Type === 'matrix-one' ? 'block' : 'none'}}>
        <div
        id="matrix-grid-container"
        style={{
            display: 'grid',
            // first column fixed at 380px; the rest flex equally;
            // an optional right-statement column when bipolar is on
            gridTemplateColumns: `380px repeat(${matrixColumns && matrixColumns.length}, 1fr)${bipolar ? ' 380px' : ''}`,
            gap: '10px'
        }}
        >
        {/* 1) top-left corner (empty) */}
        <div />

        {/* 2) column headers */}
        {matrixColumns && matrixColumns.map(column => (
            <div key={column.ID} className="matrix-grid-header">
            <Tooltip content={column.Title || 'Naam van kolom'} top="-60px">
                <p className="matrix-grid-p-tag">{column.Title || 'Naam van kolom'}</p>
            </Tooltip>
            </div>
        ))}
        {bipolar && <div />}

        {/* 3) each data row: a fragment with 1 header cell + N checkbox cells (+ optional right header) */}
        {matrixRows && matrixRows.map(row => (
            <React.Fragment key={row.ID}>
            <div className="matrix-grid-header">
                <Tooltip content={row.Title || 'Naam van rij'} top="-60px">
                    <p className="matrix-grid-p-tag">{row.Title || 'Naam van rij'}</p>
                </Tooltip>
            </div>
            {matrixColumns && matrixColumns.map(col => (
                <div key={col.ID} className="matrix-grid-item">
                    <input type="checkbox" />
                </div>
            ))}
            {bipolar && (
                <div className="matrix-grid-header last-column">
                    <Tooltip content={row.TitleRight || 'Naam van rij rechts'} top="-60px">
                        <p className="matrix-grid-p-tag">{row.TitleRight || 'Naam van rij rechts'}</p>
                    </Tooltip>
                </div>
            )}
            </React.Fragment>
        ))}
        </div>
  </div>
  )
}

export default MatrixOneMSI